var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Repayment-title"},[_vm._v(" "+_vm._s(_vm.textTitle)+" "),_c('div',{staticClass:"icon-return",on:{"click":_vm.getWalletPage}},[_c('img',{attrs:{"src":require("../../public/icons8-return.png")}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }